import * as React from 'react'

function IconComplete(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={138}
      height={90}
      viewBox="0 0 138 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M123 15L69.226 68.741c-8.35 8.345-21.89 8.345-30.208 0L15 44.738"
        stroke="#fff"
        strokeWidth={30}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconComplete
